import { useEffect, useState } from "react";
import { api } from "../../lib/api";

export const LegalRevision = () => {
  const [docs, setDocs] = useState([]);
  useEffect(() => {
    api.get("/admin/legal").then((r) => setDocs(r.data));
  }, []);
  return (
    <section className="bg-white border border-slate-200 rounded-xl p-6 space-y-4" data-testid="legal-revision-card">
      <div>
        <h2 className="font-heading font-semibold text-lg">Textos legales</h2>
        <p className="text-sm text-slate-500">Solo visible para el superadmin. Los clientes y las empresas no ven este estado.</p>
      </div>
      <ul className="divide-y divide-slate-100">
        {docs.map((d) => (
          <li key={d.titulo} className="py-3 flex flex-wrap items-center justify-between gap-2" data-testid="legal-revision-item">
            <span className="text-sm font-medium text-slate-900">{d.titulo} <span className="font-mono text-xs text-slate-500">v{d.version}</span></span>
            <span className={`text-xs rounded-full px-2.5 py-1 ${d.revision === "pendiente_revision_legal" ? "bg-amber-100 text-amber-800" : "bg-emerald-100 text-emerald-800"}`}>
              {d.revision === "pendiente_revision_legal" ? "Pendiente de revisión legal" : "Revisado"}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
};
